<div *ngIf="mostrarBloqueio" class="backdrop-bloqueio">
  <span class="texto-bloqueio">Entre em contato com sua academia para alterar a opção de pagamento</span>
</div>

